export const howitworks = [

    {
        title: "Create a Bot Persona",
        details: "Creating a custom bot is as simple as creating giving your bot a unique name and what the bot will do.",
        image: require('../images/robot.png'),
    }
    ,
    {
        title: "Train Your Bot",
        details: "Train your bot with custom data,either inventories or frequently asked questions based on your product. The bot is now trained based on this data to correctly serve the customer.",
        image: require('../images/train.png'),
    }
    ,
    {
        title: "Deploy Your Bot",
        details: "On deploying your bot, you can implement our Interface on your application and use directly as it serves",
        image: require('../images/launch.png'),
    }
]